
import React from "react";

import logo from "assets/img/henry-schein-logo-png-transparent.png";
import sidelogo from "assets/img/HS_Thrive Unlocked__Lockup.png";

import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import ThriveSignaturegep from 'assets/img/Thrive Signaturegep.png';
import landinglogo from 'assets/img/hs_landing.png';
import bannerImage from 'assets/img/landingbanner.png';




export default function ThriveSignatureNotEligible({setNext,
  signatureData,}) {
 const accountData = {
  practiceName:
    signatureData?.practice_name ||
    signatureData?.practiceName ||
    "",

  locationAccountNumber:
    signatureData?.locationAccountNumber ||
    signatureData?.location_account_number ||
    signatureData?.shipto ||
    "",

  status: "Not Eligible",

  supportEmail: "Thrive.Support@HenrySchein.com",
};

  const handleCheckDifferentAccount = () => {
    setNext('')
    console.log("Check a different account number");
  };

  return (
    <>
      <style>{notEligibleCss}</style>

      <div className="ne-page">

        {/* =====================================================
            TOP BANNER
        ===================================================== */}

        <div className="top-banner">
            <img
                      src={bannerImage}
                      alt="Thrive Signature"
                      className="top-banner-image"
                    />

          <div className="ne-banner-content">

            <div className="ne-brand">

              <img
                src={landinglogo}
                alt="Henry Schein"
                className="ne-hs-logo"
              />

              {/* <img
                src={sidelogo}
                alt="Thrive"
                className="ne-thrive-logo"
              /> */}

            </div>

            <div className="ne-brand-divider" />

            <div className="ne-tagline">
              Save More. Do More. <span>Thrive.</span>
            </div>

          </div>

        </div>


        {/* =====================================================
            MAIN CARD
            OVERLAPS BANNER
        ===================================================== */}

        <div className="ne-card-container">

          {/* ===================================================
              PROGRESS STEPS
          =================================================== */}

          <div className="ne-steps">

            <NotEligibleStep
              number="1"
              title="Check Eligibility"
              active
            />

            <div className="ne-step-line" />

            <NotEligibleStep
              number="2"
              title="Review & Accept"
            />

            <div className="ne-step-line" />

            <NotEligibleStep
              number="3"
              title="Confirmation"
            />

          </div>


          {/* ===================================================
              PAGE TITLE
          =================================================== */}

          <h1 className="ne-title">
            Thrive Signature Eligibility
          </h1>


          {/* ===================================================
              NOT ELIGIBLE CARD
          =================================================== */}

          <div className="ne-card">

            {/* =================================================
                BRAND
            ================================================= */}

            <div className="ne-card-brand">

              <img
                src={ThriveSignaturegep}
                alt="Henry Schein"
              />

              {/* <div className="ne-card-thrive">
                thrive
                <span>Signature</span>
              </div> */}

            </div>


            {/* =================================================
                WARNING ICON
            ================================================= */}

            <div className="ne-icon-outer">

              <div className="ne-icon-inner">
                <ErrorOutlineIcon />
              </div>

            </div>


            {/* =================================================
                HEADING
            ================================================= */}

            <h2 className="ne-heading">
              Not Eligible
            </h2>


            {/* =================================================
                DESCRIPTION
            ================================================= */}

            <p className="ne-text">
              The Location Account Number you entered does not currently{' '}
              <br className="desktop-break" />
              meet the eligibility requirements for a Thrive Signature upgrade.
            </p>


            {/* =================================================
                DIVIDER
            ================================================= */}

            <div className="ne-divider" />


            {/* =================================================
                ACCOUNT INFORMATION
            ================================================= */}

            <div className="ne-info-section">

              <h3>
                Account Information
              </h3>


              <AccountRow
                label="Practice Name:"
                value={accountData.practiceName}
              />


              <AccountRow
                label="Location Account Number:"
                value={accountData.locationAccountNumber}
              />


              <div className="ne-row ne-row-last">

                <div className="ne-row-label">
                  Status:
                </div>

                <div className="ne-row-value">

                  <span className="ne-status-badge">

                    <span className="ne-status-dot" />

                    {accountData.status}

                  </span>

                </div>

              </div>

            </div>


            {/* =================================================
                BUTTON
            ================================================= */}

            <button
              type="button"
              className="ne-button"
              onClick={handleCheckDifferentAccount}
            >
              Check a Different Account Number
            </button>

          </div>


          {/* =====================================================
              BOTTOM INFO STRIP
              3 CONTENTS
          ===================================================== */}

          <div className="ne-strip">

            {/* =================================================
                ITEM 1
            ================================================= */}

            <StripItem
              icon={<StarBorderIcon />}
              title="Your Rewards membership stays active"
            >
              Your existing Rewards{' '}
              <br className="desktop-break" />
              membership is not affected{' '}
              <br className="desktop-break" />
              by this eligibility result.
            </StripItem>


            <div className="ne-strip-line" />


            {/* =================================================
                ITEM 2
            ================================================= */}

            <StripItem
              icon={<HelpOutlineIcon />}
              title="Questions?"
            >
              Contact your Henry Schein Sales Consultant{' '}
              <br className="desktop-break" />
              or{" "}
              <a
                href={`mailto:${accountData.supportEmail}`}
              >
                {accountData.supportEmail}
              </a>
              .
            </StripItem>


            <div className="ne-strip-line" />


            {/* =================================================
                ITEM 3
            ================================================= */}

            

            <StripItem
              icon={<LockOutlinedIcon style={{}} />}
              title="Secure Enrollment"
              style= {{marginTop:"10px"}}
            >
              Your information is protected.
            </StripItem>

          </div>

        </div>

      </div>
    </>
  );
}


/* =========================================================
   PROGRESS STEP
========================================================= */

const NotEligibleStep = ({
  number,
  title,
  active = false,
}) => {
  return (
    <div
      className={`ne-step ${
        active ? "active" : ""
      }`}
    >

      <div className="ne-step-circle">
        {number}
      </div>

      <div className="ne-step-title">
        {title}
      </div>

    </div>
  );
};


/* =========================================================
   ACCOUNT ROW
========================================================= */

const AccountRow = ({
  label,
  value,
}) => {
  return (
    <div className="ne-row">

      <div className="ne-row-label">
        {label}
      </div>

      <div className="ne-row-value">
        {value}
      </div>

    </div>
  );
};


/* =========================================================
   BOTTOM INFO STRIP ITEM
========================================================= */

const StripItem = ({
  icon,
  title,
  children,
}) => {
  return (
    <div className="ne-strip-item">

      <div className="ne-strip-icon">
        {icon}
      </div>

      <div className="ne-strip-text">

        <div className="ne-strip-title">
          {title}
        </div>

        <div className="ne-strip-description">
          {children}
        </div>

      </div>

    </div>
  );
};


/* =========================================================
   CSS
========================================================= */

const notEligibleCss = `

* {
  box-sizing: border-box;
}


/* =========================================================
   PAGE
========================================================= */

.ne-page {
  width: 100%;
  min-height: 100vh;

  margin: 0;

  padding: 0 0 24px;

  background: #ffffff;

  font-family:
    Arial,
    Helvetica,
    sans-serif;

  color: #1638ca;

  overflow-x: hidden;
}


/* =========================================================
   TOP BANNER
========================================================= */

// .ne-banner {
//   width: 100%;

//   height: 120px;

//   position: relative;

//   overflow: hidden;

//   background:
//     linear-gradient(
//       135deg,
//       #e3f6ff 0%,
//       #d1edfc 20%,
//       #edfaff 42%,
//       #ccecff 65%,
//       #e7f7ff 100%
//     );
// }


/* =========================================================
   LEFT DECORATION
========================================================= */

// .ne-banner::before {
//   content: "";

//   position: absolute;

//   left: -30px;
//   top: -60px;

//   width: 220px;
//   height: 190px;

//   background:
//     linear-gradient(
//       135deg,
//       transparent 45%,
//       rgba(
//         82,
//         174,
//         241,
//         0.30
//       ) 46%,
//       rgba(
//         82,
//         174,
//         241,
//         0.30
//       ) 65%,
//       transparent 66%
//     );
// }


/* =========================================================
   RIGHT DECORATION
========================================================= */

// .ne-banner::after {
//   content: "";

//   position: absolute;

//   right: 30px;
//   top: -70px;

//   width: 260px;
//   height: 200px;

//   background:
//     linear-gradient(
//       135deg,
//       transparent 45%,
//       rgba(
//         75,
//         166,
//         231,
//         0.20
//       ) 46%,
//       rgba(
//         75,
//         166,
//         231,
//         0.20
//       ) 65%,
//       transparent 66%
//     );
// }

.top-banner {
  width: 100%;
  height: 110px;
  position: relative;
  overflow: hidden;
  background: none;
}

.top-banner-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.banner-inner {
  position: relative;
  z-index: 2;
  /* existing styles */
}


/* =========================================================
   BANNER CONTENT
========================================================= */

.ne-banner-content {
  width: 100%;

  max-width: 720px;

  height: 100px;

  margin: 0 auto;

  padding: 10px 20px;

  position: relative;

  z-index: 2;

  display: flex;

  align-items: center;

  gap: 14px;
}


/* =========================================================
   BRAND
========================================================= */

.ne-brand {
  display: flex;

  flex-direction: column;

  align-items: flex-start;

  flex-shrink: 0;
}


.ne-hs-logo {
  width: 105px;

  height: auto;

  object-fit: contain;
}


.ne-thrive-logo {
  width: 110px;

  height: auto;

  margin-top: -2px;

  object-fit: contain;
}


.ne-brand-divider {
  width: 1px;

  height: 44px;

  background: #6f8fb8;
}


.ne-tagline {
  color: #103cd2;

  font-size: 18px;

  line-height: 22px;

  font-weight: 700;

  white-space: nowrap;
}


.ne-tagline span {
  color: #2f9be8;
}


/* =========================================================
   MAIN CARD
   EXACT SAME POSITION AS ELIGIBILITY SCREEN
========================================================= */

.ne-card-container {
  width: calc(100% - 28px);

  max-width: 720px;

  /*
    IMPORTANT:
    This makes the card overlap
    the banner exactly like
    ThriveSignatureEligibility.
  */

  margin: -30px auto 0;

  padding: 16px 24px 30px;

  position: relative;

  z-index: 5;

  background:
    rgba(
      255,
      255,
      255,
      0.98
    );

  border:
    1px solid #dceaf8;

  border-radius: 5px;

  box-shadow:
    0 5px 20px
    rgba(
      28,
      119,
      206,
      0.15
    );
}


/* =========================================================
   STEPS
========================================================= */

.ne-steps {
  width: 100%;

  display: flex;

  align-items: flex-start;

  justify-content: center;

  margin: 0 auto 22px;
}


.ne-step {
  width: 120px;

  flex-shrink: 0;

  display: flex;

  flex-direction: column;

  align-items: center;

  text-align: center;
}


.ne-step-circle {
  width: 22px;

  height: 22px;

  border-radius: 50%;

  display: flex;

  align-items: center;

  justify-content: center;

  background: #e9effb;

  border:
    1px solid #cbd9f1;

  color: #7185c2;

  font-size: 10px;

  font-weight: 700;
}


.ne-step.active .ne-step-circle {
  background: #1677e8;

  border-color: #1677e8;

  color: #ffffff;

  box-shadow:
    0 2px 5px
    rgba(
      20,
      112,
      229,
      0.22
    );
}


.ne-step-title {
  margin-top: 5px;

  color: #1b43cf;

  font-size: 9px;

  line-height: 11px;

  font-weight: 600;

  white-space: nowrap;
}


.ne-step-line {
  width: 90px;

  height: 1px;

  margin-top: 11px;

  background: #d2def1;
}


/* =========================================================
   PAGE TITLE
========================================================= */

.ne-title {
  margin: 0 0 20px;

  text-align: center;

  color: #1026c9;

  font-size: 28px;

  line-height: 34px;

  font-weight: 700;
}


/* =========================================================
   NOT ELIGIBLE CARD
========================================================= */

.ne-card {
  width: 100%;

  max-width: 370px;

  margin: 0 auto;

  padding: 18px 20px 20px;

  border:
    1.5px solid #4da6f0;

  border-radius: 5px;

  background: #ffffff;

  box-shadow:
    0 3px 12px
    rgba(
      45,
      130,
      220,
      0.12
    );

  text-align: center;

  overflow: hidden;
}


/* =========================================================
   CARD BRAND
========================================================= */

.ne-card-brand {
  display: flex;

  flex-direction: column;

  align-items: center;

  margin-bottom: 14px;
}


.ne-card-brand img {
  width: 140px;

  height: auto;

  object-fit: contain;
}


.ne-card-thrive {
  margin-top: -2px;

  color: #0785ed;

  font-size: 44px;

  line-height: 42px;

  font-weight: 700;

  letter-spacing: -2px;

  text-align: right;
}


.ne-card-thrive span {
  display: block;

  margin-top: 1px;

  color: #1473db;

  font-size: 11px;

  line-height: 12px;

  letter-spacing: 0;

  font-weight: 400;

  text-align: right;
}


/* =========================================================
   WARNING ICON
========================================================= */

.ne-icon-outer {
  width: 64px;

  height: 64px;

  margin:
    0 auto 10px;

  border-radius: 50%;

  display: flex;

  align-items: center;

  justify-content: center;

  background: #fdebc9;
}


.ne-icon-inner {
  width: 44px;

  height: 44px;

  display: flex;

  align-items: center;

  justify-content: center;

  color: #f4a01c;
}


.ne-icon-inner svg {
  width: 42px;

  height: 42px;
}


/* =========================================================
   HEADING + TEXT
========================================================= */

.ne-heading {
  margin:
    0 0 10px;

  color: #1026c9;

  font-size: 24px;

  line-height: 28px;

  font-weight: 700;
}


.ne-text {
  margin: 0;

  color: #5f76b8;

  font-size: 11px;

  line-height: 16px;

  font-weight: 400;
}


/* =========================================================
   DIVIDER
========================================================= */

.ne-divider {
  width: 100%;

  height: 1px;

  margin:
    14px 0 12px;

  background: #dbe5f3;
}


/* =========================================================
   ACCOUNT INFORMATION
========================================================= */

.ne-info-section {
  width: 100%;

  text-align: left;

  margin-bottom: 16px;
}


.ne-info-section h3 {
  margin:
    0 0 8px;

  color: #102bc9;

  font-size: 15px;

  line-height: 19px;

  font-weight: 700;
}


.ne-row {
  width: 100%;

  display: grid;

  grid-template-columns:
    135px 1fr;

  column-gap: 8px;

  padding:
    7px 0;

  align-items: center;

  border-bottom:
    1px solid #e1e9f4;
}


.ne-row-last {
  border-bottom: none;
}


.ne-row-label {
  color: #2441a3;

  font-size: 10px;

  line-height: 14px;

  font-weight: 400;
}


.ne-row-value {
  color: #1b2f8f;

  font-size: 10px;

  line-height: 14px;

  font-weight: 400;
}


/* =========================================================
   STATUS BADGE
========================================================= */

.ne-status-badge {
  display: inline-flex;

  align-items: center;

  gap: 6px;

  padding:
    3px 12px;

  border-radius: 12px;

  background: #fdeecf;

  color: #7a5b2a;

  font-size: 10px;

  line-height: 14px;

  font-weight: 400;
}


.ne-status-dot {
  width: 6px;

  height: 6px;

  border-radius: 50%;

  background: #f4a01c;
}


/* =========================================================
   BUTTON
========================================================= */

.ne-button {
  width: 100%;

  height: 34px;

  border: none;

  border-radius: 3px;

  background: #0879ed;

  color: #ffffff;

  font-family:
    Arial,
    Helvetica,
    sans-serif;

  font-size: 12px;

  line-height: 16px;

  font-weight: 700;

  cursor: pointer;

  box-shadow:
    0 2px 5px
    rgba(
      0,
      100,
      220,
      0.18
    );

  transition:
    background 0.15s ease;
}


.ne-button:hover {
  background: #066bd3;
}


/* =========================================================
   BOTTOM INFO STRIP
   SAME AS ThriveSignatureEligibility
========================================================= */

.ne-strip {
  width: 100%;

  margin:
    16px 0 0;

  padding:
    12px 16px;

  display: flex;

  align-items: center;

  justify-content: space-between;

  border-top:
    1px solid #d5e4f6;

  // background: #f5faff;
}


.ne-strip-line {
  width: 1px;

  align-self: stretch;

  background: #d5e4f6;

  margin:
    0 12px;
}


.ne-strip-item {
  flex: 1;

  display: flex;

  align-items: flex-start;

  gap: 8px;

  min-width: 0;
}


.ne-strip-icon {
  width: 30px;

  height: 30px;

  flex-shrink: 0;

  border-radius: 50%;

  display: flex;

  align-items: center;

  justify-content: center;

  background: #d9efff;

  color: #126de2;
}


.ne-strip-icon svg {
  width: 17px;

  height: 17px;
}


.ne-strip-text {
  min-width: 0;
}


.ne-strip-title {
  color: #173bb8;

  font-size: 9px;

  line-height: 12px;

  font-weight: 700;

  margin-bottom: 2px;
}


.ne-strip-description {
  color: #6d7fae;

  font-size: 9px;

  line-height: 11px;
}


.ne-strip-description a {
  color: #173bb8;

  text-decoration: underline;
}


/* =========================================================
   TABLET
========================================================= */

@media only screen and (max-width: 768px) {

  .ne-banner {
    height: 105px;
  }


  .ne-banner-content {
    height: 88px;

    padding:
      8px 14px;
  }


  .ne-tagline {
    font-size: 15px;
  }


  .ne-card-container {
    width:
      calc(100% - 20px);

    padding:
      14px 16px 24px;

    margin-top: -26px;
  }


  .ne-card {
    max-width: 370px;
  }

}


/* =========================================================
   MOBILE
========================================================= */

@media only screen and (max-width: 480px) {

  .desktop-break {
    display: none;
  }


  .ne-banner {
    height: 88px;
  }


  .ne-banner-content {
    height: 74px;

    padding:
      6px 10px;

    gap: 8px;
  }


  .ne-hs-logo {
    width: 58px;
  }


  .ne-thrive-logo {
    width: 80px;
  }


  .ne-brand-divider {
    height: 34px;
  }


  .ne-tagline {
    font-size: 11px;

    line-height: 14px;

    white-space: normal;
  }


  .ne-card-container {
    width:
      calc(100% - 12px);

    margin-top: -26px;

    padding:
      10px 10px 18px;
  }


  .ne-steps {
    margin-bottom: 14px;
  }


  .ne-step {
    width: 76px;
  }


  .ne-step-title {
    font-size: 7px;
  }


  .ne-step-line {
    width: 40px;
  }


  .ne-title {
    font-size: 20px;

    line-height: 25px;

    margin-bottom: 14px;
  }


  .ne-card {
    width: 100%;

    padding:
      14px 12px 16px;
  }


  .ne-heading {
    font-size: 20px;

    line-height: 24px;
  }


  .ne-text {
    font-size: 10px;

    line-height: 14px;
  }


  .ne-row {
    grid-template-columns:
      105px 1fr;
  }


  /* =====================================================
     MOBILE INFO STRIP
  ===================================================== */

  .ne-strip {
    width: 100%;

    flex-direction: column;

    align-items: stretch;

    gap: 10px;
  }


  .ne-strip-line {
    width: 100%;

    height: 1px;

    margin: 0;
  }

}

`;

